export default "__VITE_ASSET__i1$hOn3X__"